import React, { useState } from 'react'
import { CensusFileRowStatusEnum } from '../../api/enums/census-file-row-status.enum'
import { CensusFileRowTypeEnum } from '../../api/enums/census-file-row-type.enum'
import { LoadingOverlay } from '../../components/LoadingOverlay/LoadingOverlay'
import { CensusManagementPageProps } from '../../types/census-management-page-props'
import CensusReviewCsvExportButton from '../components/CensusReviewCsvExportButton'
import ReviewRecordsBase from '../components/CensusReviewRecordsBase'
import RejectSelectedButton from '../components/RejectSelectedButton'

const selectAllPayload = {
  selectAll: true as const,
  type: [CensusFileRowTypeEnum.DUPLICATE_EMPLOYEE],
  status: [CensusFileRowStatusEnum.IN_REVIEW],
}

const CensusReviewDuplicate = (props: CensusManagementPageProps) => {
  const [loading, setLoading] = useState(false)
  const { importPublicKey } = props.routeParams

  return (
    <>
      <LoadingOverlay isLoading={loading} message="Loading..." />
      <ReviewRecordsBase
        tabKey={CensusFileRowTypeEnum.DUPLICATE_EMPLOYEE}
        {...props}
        rowQueryParams={{
          censusFileRowStatuses: [CensusFileRowStatusEnum.IN_REVIEW],
          censusRowType: CensusFileRowTypeEnum.DUPLICATE_EMPLOYEE,
        }}
        actionButton={({ selectedRows, handleSubmit, counts }) => {
          const totalCount =
            counts?.[CensusFileRowTypeEnum.DUPLICATE_EMPLOYEE] ?? 0
          return (
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <RejectSelectedButton
                publicKey={importPublicKey}
                selectedRows={selectedRows}
                handleSubmit={handleSubmit}
                setLoading={setLoading}
                selectAllPayload={selectAllPayload}
                totalCount={totalCount}
              />
              <CensusReviewCsvExportButton
                publicKey={importPublicKey}
                exportType={CensusFileRowTypeEnum.DUPLICATE_EMPLOYEE}
              />
            </div>
          )
        }}
        showSearch
      />
    </>
  )
}

export default CensusReviewDuplicate
